<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t('view')}} {{$tc('sound', 1)}} {{$tc('format', 1)}}</div>
      <router-link
        class="btn-blue"
        :to="{name:'Sound Formats'}"
      >{{ $tc('sound', 1)}} {{$tc('format',1)}} {{ $tc('list', 1)}}</router-link>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Sound Format Name:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{sound_format_name}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">Format is Active:</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{sound_format_is_active}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";


export default {
  data() {
    return {
      sound_format_name: "",
      sound_format_is_active: true
    };
  },
  mounted(){
      this.getSoundFormatData()
  },
  methods: {
       getSoundFormatData() {
      const { sound_format_id } = this.$route.params;
      MasterService.GetSoundFormat({ sound_format_id: sound_format_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              (this.sound_format_name = data.Records[0].sound_format_name),
               
                (this.sound_format_is_active = data.Records[0].sound_format_is_active = "Y"
                  ? 'Yes'
                  : 'No');
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SoundFormatsComponent/viewSoundFormat.vue